module.exports = __webpack_public_path__ + "static/media/sherritt-header-0005.9b653b43.jpg";